import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import {
	callGenerateCode, callAddAgent,
	callEditAgent, callGetAgentById
} from "../../../api/callcenters/service"
import { callGetAllProvince, callGetDistrict, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie, displayUrl, FormatCurrencys, getDeviceId, convertStringToJson } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import colors from '../../../utils/colors'
import moment from "moment";
import documentType from "../../../data/documentType"
import agentType from "../../../data/agentType"
import { QRCodeCanvas } from 'qrcode.react';
import { subscribeToPubNub } from '../../../utils/pubnubService';
import { toast } from "react-toastify";
import FileUploadGrid from "../../../components/upload-file";
import Checkbox from "../../../components/common/checkBox";
import InputNumberFormat from "../../../components/input";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [dateOfBirth, setDateOfBirth] = useState(null);
	const [issueDate, setIssueDate] = useState(null);
	const [expiredDate, setExpiredDate] = useState(null);
	const [agents, setAgents] = useState({
		agentId: null, firstName: '', lastName: '', gender: 'm', phone: '', dateOfBirth: '', provinceId: '', districtId: '',
		village: '', documentType: '', documentNo: '', issueDate: '', issuePlace: '', expiredDate: '', modifiedDate: '',
		modifiedBy: '', isVerify: 0, documentImagePath: null, id: 0, carriredName: '', homeNumber: '', unitNumber: '',
		oldVerify: 0, agentCode: '', agentType: 1, size: 300, debit: 0, debitMax: 0
	});
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef(null);
	const [provinceList, setProvinceList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [qrCode, setQRCode] = useState({
		value: '', transactionId: '', total: 0
	});
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setAgents((prev) => ({
					...prev, id
				}));
				intialData(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setAgents((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}
		loadProvince();
	}, []);

	useEffect(() => {
		let pubData = subscribeToPubNub(qrCode.transactionId, null, null);
		if (pubData) {
			pubData.addListener({
				message: (event) => {
					console.log('Message received:', event.message);
					if (event.message?.transactionId) {
						toast.success(__t("uiText.text380"), {
							position: "top-left",
						});

						setQRCode({
							value: '',
							total: 0,
						});

						setAgents({
							firstName: '', lastName: '', gender: 'm', phone: '', dateOfBirth: '', provinceId: '', districtId: '',
							village: '', documentType: '', documentNo: '', issueDate: '', issuePlace: '', expiredDate: '', modifiedDate: '',
							modifiedBy: '', isVerify: 0, documentImagePath: null, id: 0, carriredName: '', homeNumber: '', unitNumber: '',
							oldVerify: 0, agentCode: '', agentType: 1,
						});

						setSelectedFile(null);
						setDateOfBirth(null);
						setExpiredDate(null);
						setIssueDate(null);
					}
					notifyListRefresh();
					navigate(-1);
				},
				status: (statusEvent) => {
					console.log("PubNub status:", statusEvent);
				},
			});
		}

		return () => {
			pubData?.unsubscribeAll();
		};
	}, [qrCode.transactionId]);

	const generateAgentCode = async (provinceId) => {
		const res = await dispatch(callGenerateCode({ provinceId }));
		if (res?.payload?.responseCode === "00000") {
			setAgents((prev) => ({
				...prev,
				agentCode: res?.payload?.data?.agentCode,
			}));
		}
	}

	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}

	const intialData = async (id) => {
		const res = await dispatch(callGetAgentById({ agentId: id }))
		if (res?.payload?.responseCode === "00000") {
			let data = res?.payload?.data
			console.log("agent data", data)
			loadDistrict(data?.provinceId);
			setAgents((prev) => ({
				...prev,
				id,
				agentTypeOld: data?.configCommissionId,
				agentType: data?.configCommissionId,
				agentId: data?.agentId,
				debit:data?.debit,
				debitMax:data?.debitMax,
				agentCode: data?.agentCode,
				firstName: data?.firstName,
				lastName: data?.lastName,
				gender: data?.gender,
				phone: data?.phone,
				dateOfBirth: moment(data?.dateOfBirth).format("YYYY-MM-DD"),
				documentNo: data?.documentNo,
				documentType: data?.documentTypeId,
				documentImagePath: data?.documentImagePath ? convertStringToJson(data?.documentImagePath) : '',
				village: data?.village,
				issueDate: data?.issueDate,
				issuePlace: data?.issuePlace || '',
				expiredDate: data?.expiredDate,
				provinceId: data?.provinceId,
				districtId: data?.districtId,
				isVerify: data?.isVerify,
				homeNumber: data?.homeNumber,
				unitNumber: data?.unitNumber,
				oldVerify: data?.isVerify,
			}));


			setDateOfBirth(moment(data?.dateOfBirth).format("YYYY-MM-DD"))
			setIssueDate(data?.issueDate != null ? moment(data?.issueDate).format("YYYY-MM-DD") : null)
			setExpiredDate(data?.expiredDate != null ? moment(data?.expiredDate).format("YYYY-MM-DD") : null)

		}
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
		setAgents({
			...agents,
			[name]: value,
		});
	};

	const selectedProvince = async (e) => {
		e.preventDefault();
		setAgents((prev) => ({
			...prev,
			provinceId: e.target.value
		}));

		loadDistrict(e.target.value);

		if (!agents.agentCode) {
			generateAgentCode(e.target.value);
		}
	}

	const selectedDistrict = (e) => {
		e.preventDefault();
		setAgents((prev) => ({
			...prev,
			districtId: e.target.value
		}));
	}

	const loadDistrict = async (proId) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			setDistrictList(rs?.payload?.data)
		}
	}

	const selectedDocument = (e) => {
		e.preventDefault();
		setAgents((prev) => ({
			...prev,
			documentType: e.target.value
		}));
	}

	const selectedAgentType = (e) => {
		e.preventDefault();
		setAgents((prev) => ({
			...prev,
			agentType: e.target.value
		}));
	}

	const handleSave = async (e) => {
		e.preventDefault()

		if (agents.agentId == null && selectedFile?.file == undefined) {
			Swal.fire(__t("uiText.text023"), __t("uiText.text177"), "error");
			return
		}

		try {
			Swal.fire({
				name: t("nameSave"),
				text: t("confirmSave"),
				icon: "warning",
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: colors.confirmMessage,
				cancelButtonColor: colors.cancel,
				confirmButtonText: t('confirm'),
				cancelButtonText: t('cancel')
			}).then(async (result) => {
				if (result.isConfirmed) {
					try {

						let docPath = null
						if (selectedFile !== null) {
							const upload = await dispatch(callUploadFile(selectedFile.file));
							if (upload?.payload?.responseCode === "00000") {
								docPath = upload?.payload?.data
							}
						} else {
							docPath = agents.documentImagePath
						}

						let req = {
							registerMore: agents.agentTypeOld != null && agents.agentTypeOld != Number(agents.agentType) ? 1 : null,
							insuranceTypeOld: agents.agentTypeOld,
							agentId: agents.agentId,
							debit:agents.debit,
							debitMax:agents.debitMax,
							agentCode: agents.agentCode,
							firstName: agents.firstName,
							lastName: agents.lastName,
							gender: agents.gender,
							dateOfBirth: dateOfBirth,
							insuranceType: Number(agents.agentType) ?? null,
							documentNo: agents.documentNo,
							documentTypeId: agents.documentType,
							documentImagePath: JSON.stringify(docPath),
							issueDate: (issueDate != null ? moment(issueDate).format("YYYY-MM-DD") : null),
							expiredDate: (expiredDate != null ? moment(expiredDate).format("YYYY-MM-DD") : null),
							issuePlace: agents.issuePlace,
							homeNumber: agents.homeNumber,
							unitNumber: agents.unitNumber,
							phone: agents.phone,
							provinceId: agents.provinceId,
							districtId: agents.districtId,
							village: agents.village,
							carriredName: agents.carriredName,
							isVerify: agents.isVerify,
							deviceId: getDeviceId(),
							bankName: null,
							bankAccount: null,
							agentType: agents.agentType
						}
						console.log(req)
						let res = null;
						// if (agents.agentId == null) {
						res = await dispatch(callAddAgent(req));
						// } else {
						// res = await dispatch(callEditAgent(req));
						// }

						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								if (res?.payload?.calculate?.total > 0) {
									setQRCode({
										value: res?.payload?.data,
										transactionId: res?.payload?.calculate?.transactionId,
										total: res?.payload?.calculate?.total,
									})
								} else {
									notifyListRefresh();
									navigate(-1);
								}
							});
						} else {
							Swal.fire(__t("uiText.text023"), res?.payload?.responseCode + " - " + res?.payload?.responseDescription, "error");
						}
					} catch (error) {
						Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
					}
				}
			});
		} catch (error) {
			console.error("error: ", error)
		}
	}

	const triggerFileInput = () => {
		fileInputRef.current.click();
	};

	const cancelSeletedFile = () => {
		setSelectedFile(null);
		if (agents.documentImagePath !== null) {
			setAgents((prev) => ({
				...prev,
				documentImagePath: null,
			}));
		}
	};


	const handleImageSelect = (e) => {
		setSelectedFile({ file: e });
	};



	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("callcenter.agent.edit") : t("callcenter.agent.add")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.agentCode')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="agentCode"
													className="form-control-uld"
													placeholder={t('callcenter.agent.agentCode')}
													onChange={handleChange}
													value={agents.agentCode}
												/>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('callcenter.agent.firstName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('callcenter.agent.firstName')}
													onChange={handleChange}
													value={agents.firstName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('callcenter.agent.lastName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('callcenter.agent.lastName')}
													onChange={handleChange}
													value={agents.lastName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.dateOfBirth')} <span className="text-danger">*</span> </label>
												<DatePicker
													selected={dateOfBirth}
													onChange={date => setDateOfBirth(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.agent.dateOfBirth')}
													className="form-control-uld"
													required
												/>
											</div>

											<div className="col-md-2 form-group">
												<label>{t('callcenter.agent.gender')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="gender"
													onChange={handleChange}
													value={agents.gender}
													required
												>
													<option key={"m"} value={"m"}>{t("gender.m")}</option>
													<option key={"f"} value={"f"}>{t("gender.f")}</option>
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('callcenter.agent.phone')}
													onChange={handleChange}
													value={agents.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.provinceName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="provinceName"
													onChange={selectedProvince}
													value={agents.provinceId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.districtName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="districtName"
													onChange={selectedDistrict}
													value={agents.districtId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList.map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-3 form-group">
												<label> {t('callcenter.agent.village')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('callcenter.agent.village')}
													onChange={handleChange}
													value={agents.village}
													autoComplete="off" />
											</div>

											<div className="col-md-3 form-group">
												<label>{t('callcenter.agent.agentType')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="agentType"
													disabled={agents.agentType == '3'}
													onChange={selectedAgentType}
													value={agents.agentType}
												>
													{
														agentType.map((item) => (
															<option key={item.id} value={item.id}>{t(item.name)}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label>{t('callcenter.agent.isVerify')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="isVerify"
													onChange={handleChange}
													value={agents.isVerify}
													disabled={agents.oldVerify === 1}
													style={agents.oldVerify === 1 ? { color: colors.primary } : {}}
												>
													<option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option>
												</select>
											</div>


											<div className="col-md-2 form-group">
												<label>{t('callcenter.agent.documentType')}</label>
												<select className="chosen-single form-select"
													name="documentType"
													onChange={selectedDocument}
													value={agents.documentType}
												>
													<option key={0} value={""}>{t("selectedAll")}</option>
													{
														documentType.map((item) => (
															<option key={item.id} value={item.id}>{t(item.name)}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.documentNo')}</label>
												<input
													type="text"
													name="documentNo"
													className="form-control-uld"
													placeholder={t('callcenter.agent.documentNo')}
													onChange={handleChange}
													value={agents.documentNo}
													autoComplete="off"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.issueDate')}</label>
												<DatePicker
													selected={issueDate}
													onChange={date => setIssueDate(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.agent.issueDate')}
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.issuePlace')}</label>
												<input
													type="text"
													name="issuePlace"
													className="form-control-uld"
													placeholder={t('callcenter.agent.issuePlace')}
													onChange={handleChange}
													value={agents.issuePlace}
													autoComplete="off" />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.expiredDate')}</label>
												<DatePicker
													selected={expiredDate}
													onChange={date => setExpiredDate(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('callcenter.agent.expiredDate')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-md-2 form-group">
												<label>{t('callcenter.agent.inDebt')}</label>
												<Checkbox
													label={t('callcenter.agent.inDebt')}
													checked={agents.debit == 1}
													onChange={(e) => handleChange(e.target.checked ? { target: { value: 1, name: "debit" } } : { target: { value: 0, name: "debit" } })}
												/>
											</div>
											<div className="col-md-2 form-group">
												<label> {t('callcenter.agent.debitMax')}</label>
												<InputNumberFormat
													type="text"
													name="debitMax"
													className="form-control-uld"
													placeholder={t('callcenter.agent.debitMax')}
													onChange={(e) => handleChange(e)}
													value={agents.debitMax}
													autoComplete="off" />
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('settings.agentSpecialCommission.documentReference')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={true}
													folderName="agents"
													filesFromApi={agents.documentImagePath || []}
													onChange={handleImageSelect}
													accept="image/*,application/pdf"
												/>
											</div>

											{
												qrCode.total == 0 ? <div className="col-12 d-flex justify-content-center">
													<div className="m-3">
														<button className="theme-btn btn-style-one w-100" type="submit">
															<i className="fas fa-add"></i>&nbsp;{t("button.save")}
														</button>
													</div>
												</div> : null
											}

										</div>
									</div>
								</div>
							</div>
						</div>


						{
							qrCode.total > 0 ? <div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-12">
													<h5 className="fw-bold">{t('callcenter.agent.transactionId')}: {qrCode.transactionId}</h5>
												</div>
												<div className="col-12 d-flex justify-content-center align-items-center flex-column">
													<div style={{ position: 'relative', width: agents.size, height: agents.size }}>
														<QRCodeCanvas
															value={qrCode.value}
															size={agents.size}
															bgColor="#ffffff"
															fgColor="#000000"
															level="H"
															includeMargin={true}
														/>
														<img
															src={"/images/lti_logo.png"}
															alt="logo"
															style={{
																position: 'absolute',
																top: '50%',
																left: '50%',
																transform: 'translate(-50%, -50%)',
																width: agents.size * 0.2,
																height: agents.size * 0.2,
																borderRadius: 8,
															}}
														/>
													</div>
													<h4 className="fw-bold text-success">{t('callcenter.agent.total')}: {FormatCurrencys(qrCode.total)} {t("currentcy.kip")}</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> : null
						}
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
